import loadable from '@loadable/component';
export const manifest = {
  PublisherV2: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "PublisherV2";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "PublisherV2" */
          './publisher'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./publisher");
            }

            return eval('require.resolve')("./publisher");
          }

        }, {
          resolveComponent: mod => mod.Publisher
        })
      }
    }
  },
  SubscriberV2: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SubscriberV2";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SubscriberV2" */
          './subscriber'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./subscriber");
            }

            return eval('require.resolve')("./subscriber");
          }

        }, {
          resolveComponent: mod => mod.Subscriber
        })
      }
    }
  }
};